const emailUnsubscribeServiceUrl = `https://${process.env.REACT_APP_EMAIL_UNSUBSCRIBE_SERVICE_DOMAIN_NAME}`;

module.exports = {
  emailUnsubscribeServiceUrl,
}
